import { type IUserSettings } from "@/interfaces/api/user-settings.interface"
import { type ILayoutColumn } from "@/interfaces/component/layout-column.interface"
import { LayoutColumn } from "@/models/user_settings/layout-column.model"
import type { ThemeChoices } from "@/enums/theme-choices"
import { BaseModel } from "../base.model"

export class UserSettings extends BaseModel implements IUserSettings {
  id: string

  layoutColumnConfigs: LayoutColumn[]

  windowPosX: number
  windowPosY: number

  theme: ThemeChoices

  constructor(userSettings: IUserSettings) {
    super(userSettings)

    this.id = userSettings.id
    this.layoutColumnConfigs = []
    if (userSettings.layoutColumnConfigs) {
      userSettings.layoutColumnConfigs.forEach((layoutColumn: ILayoutColumn) => {
        if (LayoutColumn.isSupportedComponent(layoutColumn.component)) {
          this.layoutColumnConfigs.push(new LayoutColumn(layoutColumn))
        }
      })
    }

    this.windowPosX = userSettings.windowPosX
    this.windowPosY = userSettings.windowPosY
    this.theme = userSettings.theme
  }
}
